// import React, { useEffect, useState } from "react";
// import {
//     Container,
//     Typography,
//     TextField,
//     Button,
//     Paper,
//     Card,
//     CardContent,
//     IconButton,
//     Divider,
//     Box,
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     List,
//     ListItem,
//     ListItemText
// } from "@mui/material";
// import DeleteIcon from "@mui/icons-material/Delete";
// import AddIcon from "@mui/icons-material/Add";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import CloseIcon from "@mui/icons-material/Close";
// import { toast } from "react-toastify";
// import { createFeedback, deleteFeedback, fetchAllFeedbackOfBatch, getAllResponsesOfFeedback } from "helpers/feedback_helper";
// import { useParams } from "react-router-dom";
// import { Download } from "@mui/icons-material";
// import DownloadIcon from '@mui/icons-material/Download';
// import axios from "axios";
// import { url } from "helpers/url_helper";

// const Feedback = () => {
//     const [name, setName] = useState("");
//     const [questions, setQuestions] = useState([""]);
//     const [feedbacks, setFeedbacks] = useState([]);
//     const [loader, setLoader] = useState(false);
//     const [openModal, setOpenModal] = useState(false);
//     const [responseDialog, setResponseDialog] = useState({ open: false, data: [] });
//     const params = useParams();

//     const handleCreate = async () => {
//         try {
//             if (!name.trim() || questions.some(q => !q.trim())) {
//                 toast.error("Please fill out the feedback name and all questions.");
//                 return;
//             }

//             setLoader(true);
//             const data = await createFeedback({ batchId: params.id, name, questions });

//             if (data?.success) {
//                 toast.success(data?.message);
//                 fetchFeedbacks();
//                 setName("");
//                 setQuestions([""]);
//                 setOpenModal(false);
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (err) {
//             toast.error("Error: " + err?.response?.data?.message || err.message);
//         } finally {
//             setLoader(false);
//         }
//     };

//     const fetchFeedbacks = async () => {
//         try {
//             setLoader(true);
//             const data = await fetchAllFeedbackOfBatch(params.id);
//             if (data?.success) {
//                 setFeedbacks(data?.result || []);
//             }
//         } catch (err) {
//             toast.error("Error fetching feedbacks: " + err.message);
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleDelete = async (id) => {
//         try {
//             setLoader(true);
//             const data = await deleteFeedback(id);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 fetchFeedbacks();
//             } else {
//                 toast.error(data?.message);
//             }
//         } catch (err) {
//             toast.error("Error deleting feedback: " + err.message);
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleViewResponses = async (feedbackId) => {
//         try {
//             const res = await getAllResponsesOfFeedback(feedbackId);
//             if (res?.success) {
//                 setResponseDialog({ open: true, data: res.responseResult || [] });
//             } else {
//                 toast.error("Failed to load responses.");
//             }
//         } catch (err) {
//             toast.error("Error fetching responses: " + err.message);
//         }
//     };

//     useEffect(() => {
//         if (params.id) fetchFeedbacks();
//     }, [params.id]);

//     const handleAddQuestion = () => setQuestions([...questions, ""]);

//     const handleRemoveQuestion = (index) => {
//         const updated = [...questions];
//         updated.splice(index, 1);
//         setQuestions(updated);
//     };

//     const handleQuestionChange = (index, value) => {
//         const updated = [...questions];
//         updated[index] = value;
//         setQuestions(updated);
//     };

//     const downloadFeedbackExcel = async (feedbackFormId) => {
//         try {
//             const apiUrl = url + "downloadExcelFileOfFeedback";
//             const response = await axios({
//                 method: 'GET',
//                 url: `${apiUrl}/${feedbackFormId}`, // Adjust your API endpoint as needed
//                 responseType: 'blob', // Important: tells Axios to expect a binary response
//             });

//             // Create a URL for the blob and create a temporary link element
//             const url1 = window.URL.createObjectURL(new Blob([response.data]));
//             const link = document.createElement('a');
//             link.href = url1;

//             // Get the filename from the Content-Disposition header if available, otherwise default
//             const contentDisposition = response.headers['content-disposition'];
//             let filename = `feedback_responses_${feedbackFormId}.xlsx`; // Default filename
//             if (contentDisposition) {
//                 const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
//                 if (filenameMatch && filenameMatch[1]) {
//                     filename = filenameMatch[1];
//                 }
//             }

//             link.setAttribute('download', filename); // Set the download attribute
//             document.body.appendChild(link);
//             link.click(); // Programmatically click the link to trigger download
//             link.remove(); // Clean up the temporary link
//             window.URL.revokeObjectURL(url); // Clean up the URL object

//             console.log('Excel file downloaded successfully!');

//         } catch (error) {
//             console.error('Error downloading Excel file:', error);
//             // You might want to show an error message to the user
//             toast.error('Failed to download feedback responses. Please try again.');
//         }
//     };

//     return (
//         <Container maxWidth="md">
//             <Box mt={4} display="flex" justifyContent="flex-end">
//                 <Button variant="contained" onClick={() => setOpenModal(true)}>
//                     Create Feedback
//                 </Button>
//                 <Button
//                     className="ms-2"
//                     variant="contained"
//                     color="primary"
//                     startIcon={<Download />}
//                     onClick={() => { }}
//                 >
//                     Download Feedback
//                 </Button>
//             </Box>

//             {/* Create Feedback Dialog */}
//             <Dialog open={openModal} onClose={() => setOpenModal(false)} fullWidth maxWidth="sm">
//                 <DialogTitle>
//                     Create Feedback Form
//                     <IconButton onClick={() => setOpenModal(false)} sx={{ position: "absolute", right: 8, top: 8 }}>
//                         <CloseIcon />
//                     </IconButton>
//                 </DialogTitle>
//                 <DialogContent dividers>
//                     <TextField
//                         fullWidth
//                         label="Feedback Name"
//                         value={name}
//                         onChange={(e) => setName(e.target.value)}
//                         sx={{ mb: 2 }}
//                     />
//                     {questions.map((question, index) => (
//                         <Box key={index} display="flex" alignItems="center" mb={2}>
//                             <TextField
//                                 fullWidth
//                                 label={`Question ${index + 1}`}
//                                 value={question}
//                                 onChange={(e) => handleQuestionChange(index, e.target.value)}
//                             />
//                             <IconButton onClick={() => handleRemoveQuestion(index)} sx={{ ml: 1 }}>
//                                 <DeleteIcon />
//                             </IconButton>
//                         </Box>
//                     ))}
//                     <Button startIcon={<AddIcon />} onClick={handleAddQuestion} sx={{ mt: 1 }}>
//                         Add Question
//                     </Button>
//                 </DialogContent>
//                 <DialogActions>
//                     <Button onClick={() => setOpenModal(false)}>Cancel</Button>
//                     <Button variant="contained" onClick={handleCreate} disabled={loader}>
//                         {loader ? "Creating..." : "Create"}
//                     </Button>
//                 </DialogActions>
//             </Dialog>

//             {/* Feedback Cards */}
//             <Box mt={4}>
//                 <Typography variant="h6" gutterBottom>
//                     Feedbacks
//                 </Typography>

//                 {feedbacks.length === 0 ? (
//                     <Typography variant="body1" color="textSecondary">
//                         No feedbacks found.
//                     </Typography>
//                 ) : (
//                     feedbacks.map((feedback) => (
//                         <Card key={feedback.id} sx={{ mb: 3 }}>
//                             <CardContent>
//                                 <Box display="flex" justifyContent="space-between" alignItems="center">
//                                     <Typography variant="h6">{feedback.name}</Typography>
//                                     <Box>
//                                         <IconButton onClick={() => handleViewResponses(feedback.id)} color="primary">
//                                             <VisibilityIcon />
//                                         </IconButton>
//                                         <IconButton onClick={() => downloadFeedbackExcel(feedback.id)} color="success"> {/* You can choose any color */}
//                                             <DownloadIcon />
//                                         </IconButton>
//                                         <IconButton onClick={() => handleDelete(feedback.id)} color="error">
//                                             <DeleteIcon />
//                                         </IconButton>
//                                     </Box>
//                                 </Box>
//                                 <Divider sx={{ my: 1 }} />
//                             </CardContent>
//                         </Card>
//                     ))
//                 )}
//             </Box>

//             {/* Responses Dialog */}
//             <Dialog open={responseDialog.open} onClose={() => setResponseDialog({ open: false, data: [] })} fullWidth maxWidth="md">
//                 <DialogTitle>
//                     Student Responses
//                     <IconButton onClick={() => setResponseDialog({ open: false, data: [] })} sx={{ position: "absolute", right: 8, top: 8 }}>
//                         <CloseIcon />
//                     </IconButton>
//                 </DialogTitle>
//                 <DialogContent dividers>
//                     {responseDialog.data.length === 0 ? (
//                         <Typography>No responses found.</Typography>
//                     ) : (
//                         responseDialog.data.map((res, index) => (
//                             <Paper key={index} sx={{ p: 2, mb: 2 }} elevation={2}>
//                                 <Typography variant="subtitle1" fontWeight="bold">
//                                     {res.studentName} — Rating: {res.rating}
//                                 </Typography>
//                                 <List>
//                                     {res.questions.map((q, i) => (
//                                         <ListItem key={i} alignItems="flex-start">
//                                             <ListItemText
//                                                 primary={`Q${i + 1}: ${q}`}
//                                                 secondary={`Answer: ${res.answers[i] || "No answer provided"}`}
//                                             />
//                                         </ListItem>
//                                     ))}
//                                 </List>
//                             </Paper>
//                         ))
//                     )}
//                 </DialogContent>
//                 <DialogActions>
//                     <Button onClick={() => setResponseDialog({ open: false, data: [] })}>Close</Button>
//                 </DialogActions>
//             </Dialog>
//         </Container>
//     );
// };

// export default Feedback;













import React, { useEffect, useState } from "react";
import {
    Container,
    Typography,
    TextField,
    Button,
    Paper,
    Card,
    CardContent,
    IconButton,
    Divider,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    List,
    ListItem,
    ListItemText,
    Rating,
    Chip,
    Stack,
    CircularProgress,
    Tooltip,
    Alert,
    Snackbar
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import AssessmentIcon from "@mui/icons-material/Assessment";
import StarIcon from "@mui/icons-material/Star";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { Download } from "@mui/icons-material";
import DownloadIcon from '@mui/icons-material/Download';
import axios from "axios";

// Fix import paths - use relative paths from current file location
// If your helper files are in src/helpers/, use:
import { 
    createFeedback, 
    deleteFeedback, 
    fetchAllFeedbackOfBatch, 
    getAllResponsesOfFeedback
} from "../../../helpers/feedback_helper";

import { url } from "../../../helpers/url_helper";

const Feedback = () => {
    const [name, setName] = useState("");
    const [questions, setQuestions] = useState([""]);
    const [feedbacks, setFeedbacks] = useState([]);
    const [loader, setLoader] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [editingFeedbackId, setEditingFeedbackId] = useState(null);
    const [responseDialog, setResponseDialog] = useState({ open: false, data: [] });
    const [avgRatings, setAvgRatings] = useState({});
    const [loadingRatings, setLoadingRatings] = useState({});
    const [reportDialog, setReportDialog] = useState({ open: false, data: null });
    const [error, setError] = useState(null);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });
    const params = useParams();

    // Fetch all feedbacks
    const fetchFeedbacks = async () => {
        try {
            setLoader(true);
            const data = await fetchAllFeedbackOfBatch(params.id);
            if (data?.success) {
                setFeedbacks(data?.result || []);
                if (data?.result && data.result.length > 0) {
                    data.result.forEach(feedback => {
                        fetchAverageRating(feedback.id);
                    });
                }
            } else {
                setError(data?.message || "Failed to fetch feedbacks");
            }
        } catch (err) {
            console.error("Fetch error:", err);
            setError(err?.response?.data?.message || err.message);
            toast.error("Error fetching feedbacks: " + (err?.response?.data?.message || err.message));
        } finally {
            setLoader(false);
        }
    };

    // Fetch average rating
    const fetchAverageRating = async (feedbackId) => {
        try {
            setLoadingRatings(prev => ({ ...prev, [feedbackId]: true }));
            const res = await getAllResponsesOfFeedback(feedbackId);
            if (res?.success && res.responseResult?.length > 0) {
                const totalRating = res.responseResult.reduce((sum, response) => sum + (response.rating || 0), 0);
                const averageRating = totalRating / res.responseResult.length;
                setAvgRatings(prev => ({ ...prev, [feedbackId]: averageRating }));
            } else {
                setAvgRatings(prev => ({ ...prev, [feedbackId]: 0 }));
            }
        } catch (err) {
            console.error("Error fetching rating:", err);
            setAvgRatings(prev => ({ ...prev, [feedbackId]: 0 }));
        } finally {
            setLoadingRatings(prev => ({ ...prev, [feedbackId]: false }));
        }
    };

    // Create feedback
    const handleCreate = async () => {
        if (!name.trim()) {
            toast.error("Please enter feedback name");
            return;
        }
        
        const emptyQuestions = questions.some(q => !q.trim());
        if (emptyQuestions || questions.length === 0) {
            toast.error("Please add at least one question and ensure all questions are filled");
            return;
        }

        try {
            setLoader(true);
            const payload = { 
                batchId: params.id, 
                name: name.trim(), 
                questions: questions.filter(q => q.trim()) 
            };
            
            const data = await createFeedback(payload);

            if (data?.success) {
                toast.success(data?.message || "Feedback created successfully!");
                resetForm();
                setOpenModal(false);
                await fetchFeedbacks();
            } else {
                toast.error(data?.message || "Failed to create feedback");
            }
        } catch (err) {
            console.error("Create error:", err);
            toast.error(err?.response?.data?.message || err.message || "Error creating feedback");
        } finally {
            setLoader(false);
        }
    };

    // Update feedback
    const handleUpdate = async () => {
        if (!name.trim()) {
            toast.error("Please enter feedback name");
            return;
        }
        
        const emptyQuestions = questions.some(q => !q.trim());
        if (emptyQuestions || questions.length === 0) {
            toast.error("Please add at least one question and ensure all questions are filled");
            return;
        }

        if (!editingFeedbackId) {
            toast.error("No feedback selected for editing");
            return;
        }

        try {
            setLoader(true);
            const payload = { 
                name: name.trim(), 
                questions: questions.filter(q => q.trim()) 
            };
            
            // Try multiple API endpoints
            let data = null;
            let error = null;
            
            const endpoints = [
                `${url}feedback/update/${editingFeedbackId}`,
                `${url}feedback/${editingFeedbackId}`,
                `${url}feedback/edit/${editingFeedbackId}`
            ];
            
            for (const endpoint of endpoints) {
                try {
                    const response = await axios.put(endpoint, payload);
                    if (response.data?.success) {
                        data = response.data;
                        break;
                    }
                } catch (err) {
                    error = err;
                }
            }
            
            if (data?.success) {
                toast.success(data?.message || "Feedback updated successfully!");
                resetForm();
                setOpenModal(false);
                setEditMode(false);
                setEditingFeedbackId(null);
                await fetchFeedbacks();
            } else {
                toast.error(error?.response?.data?.message || "Failed to update feedback");
            }
        } catch (err) {
            console.error("Update error:", err);
            toast.error(err?.response?.data?.message || err.message || "Error updating feedback");
        } finally {
            setLoader(false);
        }
    };

    // Delete feedback
    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this feedback?")) {
            try {
                setLoader(true);
                const data = await deleteFeedback(id);
                if (data?.success) {
                    toast.success(data?.message || "Feedback deleted successfully!");
                    await fetchFeedbacks();
                } else {
                    toast.error(data?.message || "Failed to delete feedback");
                }
            } catch (err) {
                console.error("Delete error:", err);
                toast.error("Error deleting feedback: " + (err?.response?.data?.message || err.message));
            } finally {
                setLoader(false);
            }
        }
    };

    // Edit feedback
    const handleEdit = (feedback) => {
        setEditMode(true);
        setEditingFeedbackId(feedback.id);
        setName(feedback.name || "");
        setQuestions(feedback.questions && feedback.questions.length > 0 ? feedback.questions : [""]);
        setOpenModal(true);
    };

    // View responses
    const handleViewResponses = async (feedbackId) => {
        try {
            setLoader(true);
            const res = await getAllResponsesOfFeedback(feedbackId);
            if (res?.success) {
                setResponseDialog({ open: true, data: res.responseResult || [] });
            } else {
                toast.error(res?.message || "Failed to load responses.");
            }
        } catch (err) {
            console.error("View responses error:", err);
            toast.error("Error fetching responses: " + (err?.response?.data?.message || err.message));
        } finally {
            setLoader(false);
        }
    };

    // Generate report
    const handleGenerateReport = async (feedback) => {
        try {
            setLoader(true);
            const res = await getAllResponsesOfFeedback(feedback.id);
            if (res?.success) {
                const reportData = {
                    feedbackId: feedback.id,
                    feedbackName: feedback.name,
                    totalResponses: res.responseResult?.length || 0,
                    averageRating: avgRatings[feedback.id] || 0,
                    responses: res.responseResult || [],
                    questions: feedback.questions || []
                };
                setReportDialog({ open: true, data: reportData });
            } else {
                toast.error(res?.message || "Failed to generate report.");
            }
        } catch (err) {
            console.error("Generate report error:", err);
            toast.error("Error generating report: " + (err?.response?.data?.message || err.message));
        } finally {
            setLoader(false);
        }
    };

    // Download feedback Excel
    const downloadFeedbackExcel = async (feedbackFormId) => {
        try {
            const apiUrl = url + "downloadExcelFileOfFeedback";
            const response = await axios({
                method: 'GET',
                url: `${apiUrl}/${feedbackFormId}`,
                responseType: 'blob',
            });

            const url1 = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url1;

            const contentDisposition = response.headers['content-disposition'];
            let filename = `feedback_responses_${feedbackFormId}.xlsx`;
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1];
                }
            }

            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url1);
            toast.success("Excel file downloaded successfully!");
        } catch (error) {
            console.error('Error downloading Excel file:', error);
            toast.error('Failed to download feedback responses. Please try again.');
        }
    };

    // Reset form
    const resetForm = () => {
        setName("");
        setQuestions([""]);
        setEditMode(false);
        setEditingFeedbackId(null);
        setError(null);
    };

    // Handle modal close
    const handleModalClose = () => {
        resetForm();
        setOpenModal(false);
    };

    // Add/Remove questions
    const handleAddQuestion = () => setQuestions([...questions, ""]);
    
    const handleRemoveQuestion = (index) => {
        if (questions.length === 1) {
            toast.warning("Cannot remove the last question");
            return;
        }
        const updated = [...questions];
        updated.splice(index, 1);
        setQuestions(updated);
    };
    
    const handleQuestionChange = (index, value) => {
        const updated = [...questions];
        updated[index] = value;
        setQuestions(updated);
    };

    useEffect(() => {
        if (params.id) {
            fetchFeedbacks();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.id]);

    return (
        <Container maxWidth="lg">
            <Snackbar 
                open={snackbar.open} 
                autoHideDuration={6000} 
                onClose={() => setSnackbar({ ...snackbar, open: false })}
            >
                <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
                    {snackbar.message}
                </Alert>
            </Snackbar>

            <Box mt={4} display="flex" justifyContent="flex-end" gap={2}>
                <Button 
                    variant="contained" 
                    onClick={() => setOpenModal(true)}
                    startIcon={<AddIcon />}
                >
                    Create Feedback
                </Button>
            </Box>

            {/* Create/Edit Feedback Dialog */}
            <Dialog open={openModal} onClose={handleModalClose} fullWidth maxWidth="sm">
                <DialogTitle>
                    {editMode ? "Edit Feedback Form" : "Create Feedback Form"}
                    <IconButton onClick={handleModalClose} sx={{ position: "absolute", right: 8, top: 8 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <TextField
                        fullWidth
                        label="Feedback Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        sx={{ mb: 2 }}
                        required
                    />
                    <Typography variant="subtitle2" gutterBottom>
                        Questions ({questions.length})
                    </Typography>
                    {questions.map((question, index) => (
                        <Box key={index} display="flex" alignItems="center" mb={2}>
                            <TextField
                                fullWidth
                                label={`Question ${index + 1}`}
                                value={question}
                                onChange={(e) => handleQuestionChange(index, e.target.value)}
                                required
                            />
                            <IconButton 
                                onClick={() => handleRemoveQuestion(index)} 
                                sx={{ ml: 1 }}
                                disabled={questions.length === 1}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </Box>
                    ))}
                    <Button startIcon={<AddIcon />} onClick={handleAddQuestion} sx={{ mt: 1 }}>
                        Add Question
                    </Button>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleModalClose}>Cancel</Button>
                    <Button 
                        variant="contained" 
                        onClick={editMode ? handleUpdate : handleCreate} 
                        disabled={loader || !name.trim() || questions.some(q => !q.trim())}
                    >
                        {loader ? (editMode ? "Updating..." : "Creating...") : (editMode ? "Update" : "Create")}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Feedback Cards */}
            <Box mt={4}>
                <Typography variant="h6" gutterBottom>
                    Feedbacks ({feedbacks.length})
                </Typography>

                {loader && feedbacks.length === 0 ? (
                    <Box display="flex" justifyContent="center" py={4}>
                        <CircularProgress />
                    </Box>
                ) : feedbacks.length === 0 ? (
                    <Paper sx={{ p: 4, textAlign: "center" }}>
                        <Typography variant="body1" color="textSecondary">
                            No feedbacks found. Click "Create Feedback" to get started.
                        </Typography>
                    </Paper>
                ) : (
                    feedbacks.map((feedback) => (
                        <Card key={feedback.id} sx={{ mb: 3 }}>
                            <CardContent>
                                <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
                                    <Box>
                                        <Typography variant="h6">{feedback.name}</Typography>
                                        <Box display="flex" alignItems="center" mt={1} flexWrap="wrap" gap={1}>
                                            {loadingRatings[feedback.id] ? (
                                                <CircularProgress size={20} />
                                            ) : (
                                                <>
                                                    <Rating
                                                        value={avgRatings[feedback.id] || 0}
                                                        precision={0.5}
                                                        readOnly
                                                        size="small"
                                                        emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                                                    />
                                                    <Typography variant="body2" color="textSecondary">
                                                        ({avgRatings[feedback.id]?.toFixed(1) || 0} / 5.0)
                                                    </Typography>
                                                    <Chip 
                                                        label={`${feedback.responseCount || 0} responses`} 
                                                        size="small" 
                                                        variant="outlined"
                                                    />
                                                </>
                                            )}
                                        </Box>
                                    </Box>
                                    <Stack direction="row" spacing={1} sx={{ mt: { xs: 2, sm: 0 } }}>
                                        <Tooltip title="View Responses">
                                            <IconButton onClick={() => handleViewResponses(feedback.id)} color="primary">
                                                <VisibilityIcon />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Edit Feedback">
                                            <IconButton onClick={() => handleEdit(feedback)} color="info">
                                                <EditIcon />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Generate Report">
                                            <IconButton onClick={() => handleGenerateReport(feedback)} color="secondary">
                                                <AssessmentIcon />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Download Excel">
                                            <IconButton onClick={() => downloadFeedbackExcel(feedback.id)} color="success">
                                                <DownloadIcon />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Delete Feedback">
                                            <IconButton onClick={() => handleDelete(feedback.id)} color="error">
                                                <DeleteIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Stack>
                                </Box>
                                <Divider sx={{ my: 1.5 }} />
                                <Typography variant="body2" color="textSecondary">
                                    Questions: {feedback.questions?.length || 0}
                                </Typography>
                            </CardContent>
                        </Card>
                    ))
                )}
            </Box>

            {/* Responses Dialog */}
            <Dialog open={responseDialog.open} onClose={() => setResponseDialog({ open: false, data: [] })} fullWidth maxWidth="md">
                <DialogTitle>
                    Student Responses
                    <IconButton onClick={() => setResponseDialog({ open: false, data: [] })} sx={{ position: "absolute", right: 8, top: 8 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {responseDialog.data.length === 0 ? (
                        <Typography>No responses found.</Typography>
                    ) : (
                        responseDialog.data.map((res, index) => (
                            <Paper key={index} sx={{ p: 2, mb: 2 }} elevation={2}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                    <Typography variant="subtitle1" fontWeight="bold">
                                        {res.studentName || `Student ${index + 1}`}
                                    </Typography>
                                    <Box display="flex" alignItems="center">
                                        <Rating value={res.rating || 0} readOnly size="small" />
                                        <Typography variant="body2" sx={{ ml: 1 }}>
                                            ({res.rating || 0}/5)
                                        </Typography>
                                    </Box>
                                </Box>
                                <List dense>
                                    {res.questions?.map((q, i) => (
                                        <ListItem key={i} alignItems="flex-start" sx={{ px: 0 }}>
                                            <ListItemText
                                                primary={`Q${i + 1}: ${q}`}
                                                secondary={`Answer: ${res.answers?.[i] || "No answer provided"}`}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </Paper>
                        ))
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setResponseDialog({ open: false, data: [] })}>Close</Button>
                </DialogActions>
            </Dialog>

            {/* Report Dialog */}
            <Dialog open={reportDialog.open} onClose={() => setReportDialog({ open: false, data: null })} fullWidth maxWidth="lg">
                <DialogTitle>
                    Feedback Report: {reportDialog.data?.feedbackName}
                    <IconButton onClick={() => setReportDialog({ open: false, data: null })} sx={{ position: "absolute", right: 8, top: 8 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {reportDialog.data && (
                        <>
                            <Paper sx={{ p: 3, mb: 3, bgcolor: '#f5f5f5' }}>
                                <Typography variant="h6" gutterBottom>Summary Report</Typography>
                                <Box display="flex" justifyContent="space-between" flexWrap="wrap" gap={2}>
                                    <Box>
                                        <Typography variant="body2" color="textSecondary">Total Responses</Typography>
                                        <Typography variant="h4">{reportDialog.data.totalResponses}</Typography>
                                    </Box>
                                    <Box>
                                        <Typography variant="body2" color="textSecondary">Average Rating</Typography>
                                        <Box display="flex" alignItems="center">
                                            <Typography variant="h4" mr={1}>{reportDialog.data.averageRating?.toFixed(1)}</Typography>
                                            <Rating value={reportDialog.data.averageRating || 0} precision={0.5} readOnly />
                                        </Box>
                                    </Box>
                                    <Box>
                                        <Typography variant="body2" color="textSecondary">Total Questions</Typography>
                                        <Typography variant="h4">{reportDialog.data.questions?.length || 0}</Typography>
                                    </Box>
                                </Box>
                            </Paper>

                            {reportDialog.data.totalResponses > 0 && (
                                <>
                                    <Typography variant="h6" gutterBottom>Rating Distribution</Typography>
                                    <Paper sx={{ p: 2, mb: 3 }}>
                                        {[5, 4, 3, 2, 1].map(rating => {
                                            const count = reportDialog.data.responses?.filter(r => Math.floor(r.rating) === rating).length || 0;
                                            const percentage = reportDialog.data.totalResponses > 0 ? (count / reportDialog.data.totalResponses) * 100 : 0;
                                            return (
                                                <Box key={rating} display="flex" alignItems="center" mb={1}>
                                                    <Typography variant="body2" sx={{ width: 40 }}>{rating} Star</Typography>
                                                    <Box flex={1} mx={1}>
                                                        <Box sx={{ height: 8, bgcolor: '#e0e0e0', borderRadius: 4, overflow: 'hidden' }}>
                                                            <Box sx={{ width: `${percentage}%`, height: '100%', bgcolor: '#ffb400', borderRadius: 4 }} />
                                                        </Box>
                                                    </Box>
                                                    <Typography variant="body2" sx={{ width: 80 }}>{count} ({percentage.toFixed(0)}%)</Typography>
                                                </Box>
                                            );
                                        })}
                                    </Paper>
                                </>
                            )}

                            <Typography variant="h6" gutterBottom>All Responses</Typography>
                            {reportDialog.data.responses?.length === 0 ? (
                                <Typography>No responses yet.</Typography>
                            ) : (
                                reportDialog.data.responses?.map((res, index) => (
                                    <Paper key={index} sx={{ p: 2, mb: 2 }} elevation={2}>
                                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                            <Typography variant="subtitle1" fontWeight="bold">
                                                {index + 1}. {res.studentName || `Student ${index + 1}`}
                                            </Typography>
                                            <Chip 
                                                label={`Rating: ${res.rating || 0}/5`} 
                                                color={res.rating >= 4 ? "success" : res.rating >= 3 ? "warning" : "error"}
                                                size="small"
                                            />
                                        </Box>
                                        <List dense>
                                            {reportDialog.data.questions?.map((q, i) => (
                                                <ListItem key={i} sx={{ px: 0 }}>
                                                    <ListItemText
                                                        primary={`Q${i + 1}: ${q}`}
                                                        secondary={`Answer: ${res.answers?.[i] || "No answer"}`}
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Paper>
                                ))
                            )}
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button 
                        variant="contained" 
                        onClick={() => downloadFeedbackExcel(reportDialog.data?.feedbackId)}
                        startIcon={<DownloadIcon />}
                    >
                        Download Excel Report
                    </Button>
                    <Button onClick={() => setReportDialog({ open: false, data: null })}>Close</Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
};

export default Feedback;